import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

// Shared "Unsaved changes" modal — matches Figma node 65-4054 (referenced by MAX-3831).
// Layout: 24px padding all around; Body block (title row → divider → message) with 16px gaps,
// then a 32px gap to the right-aligned Actions row.
export const styles = (theme: Theme) =>
	({
		paper: {
			width: 560,
			maxWidth: "100%",
			borderRadius: 8,
			padding: 24,
			margin: 16,
		},
		body: {
			display: "flex",
			flexDirection: "column",
			gap: 16,
			padding: 0,
			// Cancel MUI DialogContent's default first/last-child padding tweaks.
			"&:first-child": {
				paddingTop: 0,
			},
		},
		titleRow: {
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			width: "100%",
		},
		titleLeft: {
			display: "flex",
			alignItems: "center",
			gap: 8,
		},
		warningIcon: {
			color: "#9D6506",
			flexShrink: 0,
		},
		// Figma H4: SF Pro Bold 24/32, text/primary.
		titleText: {
			fontSize: 24,
			fontWeight: 700,
			lineHeight: "32px",
			color: theme.palette.custom.textPrimary,
		},
		closeButton: {
			padding: 0,
			// #5F6368 to match the other page modals' close icon (MAX-3831 review).
			color: theme.palette.custom.textSecondary,
		},
		divider: {
			width: "100%",
		},
		// Figma Body1: SF Pro Regular 18/24, text/primary.
		bodyText: {
			fontSize: 18,
			fontWeight: 400,
			lineHeight: "24px",
			color: theme.palette.custom.textPrimary,
		},
		actions: {
			display: "flex",
			gap: 8,
			padding: 0,
			marginTop: 32,
		},
		// Outlined secondary action — 2px teal border, teal text (Figma).
		// Fixed 36px height; border-box keeps the 2px border inside the height.
		leaveButton: {
			height: 36,
			boxSizing: "border-box",
			border: `2px solid ${theme.palette.custom.tertiaryAction}`,
			color: theme.palette.custom.tertiaryAction,
			borderRadius: 8,
			fontWeight: 590,
			padding: "0 16px",
			"&:hover": {
				border: `2px solid ${theme.palette.custom.tertiaryAction}`,
			},
		},
		// Filled primary action — teal fill, white text (Figma).
		// Transparent 2px border + fixed 36px height so both actions match exactly.
		stayButton: {
			height: 36,
			boxSizing: "border-box",
			backgroundColor: theme.palette.custom.tertiaryAction,
			color: "#ffffff",
			border: "2px solid transparent",
			borderRadius: 8,
			fontWeight: 590,
			padding: "0 16px",
			"&:hover": {
				backgroundColor: theme.palette.custom.tertiaryAction,
			},
		},
	} satisfies Record<string, CSSObject>);
